export default __webpack_public_path__ + "static/media/greyIIcon.89f5c25b.svg";